/**
 * Returns `true` if the provided `pathname` corresponds to a reports page.
 */
export const isReportsPage = (pathname: string = ''): boolean => {
  const IS_REPORTS_PAGE_REG_EXP = /reports/gi;

  return IS_REPORTS_PAGE_REG_EXP.test(pathname);
};



// WEBPACK FOOTER //
// ./src/app/utils/route.js